import { ProductCardSkeleton } from '../ProductCard';
import { PRODUCT_LIST_CONST, type SkeletonListProps } from './ProductList.d';
import { ProductList } from './ProductList.styles';

const ProductListSkeleton = ({ itemsPerRowDesktop = 4, quantity = 4 }: SkeletonListProps) => (
  <ProductList data-items-desktop={itemsPerRowDesktop} data-testid={PRODUCT_LIST_CONST.TEST_ID}>
    {[...Array(quantity)].map((_, index) => (
      <ProductCardSkeleton key={index} />
    ))}
  </ProductList>
);

export default ProductListSkeleton;
